import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Menu',
    href: '#menu'
  }, {
    name: 'Desserts',
    href: '#desserts'
  }, {
    name: 'Merch',
    href: '#merch'
  }, {
    name: 'Community',
    href: '#community'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-hope-cream/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-157">
        <a href="#" className="flex items-center gap-3 group" data-id="element-158">
          <img src="https://cdn.magicpatterns.com/uploads/1GsN8Dz1rZCZJiijDwSn26/logo.png" alt="HOPE Cafetería" className="h-40 w-auto transition-transform group-hover:scale-105" data-id="element-159" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-160">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium hover:text-hope-terracotta transition-colors" data-id="element-161">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-hope-brown" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-162">
          {isMobileMenuOpen ? <X size={24} data-id="element-163" /> : <Menu size={24} data-id="element-164" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-hope-cream border-t border-hope-mustard/20 shadow-lg py-4 px-6 flex flex-col gap-4" data-id="element-165">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium py-2 border-b border-hope-mustard/10" onClick={() => setIsMobileMenuOpen(false)} data-id="element-166">
              {link.name}
            </a>)}
        </div>}
    </header>;
}